import { NotFoundError } from "src/components/pages/ErrorPage"
import { getStaticProps } from "src/helpers/getStaticProps"

export { getStaticProps }

export default NotFoundError
